<template>
  <div>
    <h2>
      Weight
    </h2>
    <el-form
      ref="form"
      :model="item"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Minimum"
            prop="weight_min"
          >
            <el-input
              v-model="item.weight_min"
              type="number"
              placeholder="Minimum"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Maximum"
            prop="weight_max"
          >
            <el-input
              v-model="item.weight_max"
              type="number"
              placeholder="Maximum"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }

  },
  data () {
    return {
      rules: {
        weight_min: [
          { required: true, message: 'Item Minimum is required.', trigger: ['blur'] }
        ],
        weight_max: [
          { required: true, message: 'Item Maximum is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
